module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_38.adba444b.png";